module.exports = __webpack_public_path__ + "fonts/FavoritPro-Regular.d5fb6740.woff";